"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/spwn_ec/v1/legacy_portal_common.proto (package spwn.spwn_ec.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyPortalLiveCommerceProductVariant = exports.LegacyPortalLiveCommerceProduct = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * ライブコマース商品（Shopify の Product）
 *
 * @generated from message spwn.spwn_ec.v1.LegacyPortalLiveCommerceProduct
 */
class LegacyPortalLiveCommerceProduct extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * Shopify の Product GID
         *
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: string handle = 2;
         */
        this.handle = "";
        /**
         * @generated from field: string title = 3;
         */
        this.title = "";
        /**
         * @generated from field: string description_html = 4;
         */
        this.descriptionHtml = "";
        /**
         * 商品画像のURL一覧
         *
         * @generated from field: repeated string image_urls = 6;
         */
        this.imageUrls = [];
        /**
         * バリエーション一覧
         *
         * @generated from field: repeated spwn.spwn_ec.v1.LegacyPortalLiveCommerceProductVariant variants = 7;
         */
        this.variants = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalLiveCommerceProduct().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalLiveCommerceProduct().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalLiveCommerceProduct().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalLiveCommerceProduct, a, b);
    }
}
exports.LegacyPortalLiveCommerceProduct = LegacyPortalLiveCommerceProduct;
LegacyPortalLiveCommerceProduct.runtime = protobuf_1.proto3;
LegacyPortalLiveCommerceProduct.typeName = "spwn.spwn_ec.v1.LegacyPortalLiveCommerceProduct";
LegacyPortalLiveCommerceProduct.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "handle", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description_html", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "featured_image_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "image_urls", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "variants", kind: "message", T: LegacyPortalLiveCommerceProductVariant, repeated: true },
]);
/**
 * ライブコマース商品のバリエーション（Shopify の ProductVariant）
 *
 * @generated from message spwn.spwn_ec.v1.LegacyPortalLiveCommerceProductVariant
 */
class LegacyPortalLiveCommerceProductVariant extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * Shopify の ProductVariant GID。カート投入時の merchandise ID になる
         *
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: string title = 2;
         */
        this.title = "";
        /**
         * 税込価格（円・整数）
         *
         * @generated from field: int32 price_amount = 3;
         */
        this.priceAmount = 0;
        /**
         * @generated from field: string currency_code = 4;
         */
        this.currencyCode = "";
        /**
         * @generated from field: bool available_for_sale = 5;
         */
        this.availableForSale = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalLiveCommerceProductVariant().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalLiveCommerceProductVariant().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalLiveCommerceProductVariant().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalLiveCommerceProductVariant, a, b);
    }
}
exports.LegacyPortalLiveCommerceProductVariant = LegacyPortalLiveCommerceProductVariant;
LegacyPortalLiveCommerceProductVariant.runtime = protobuf_1.proto3;
LegacyPortalLiveCommerceProductVariant.typeName = "spwn.spwn_ec.v1.LegacyPortalLiveCommerceProductVariant";
LegacyPortalLiveCommerceProductVariant.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "price_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "currency_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "available_for_sale", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "quantity_available", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
]);
//# sourceMappingURL=legacy_portal_common_pb.js.map